import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import SweetAlertService from "../../../services/SweetAlertService";
import { contentAsDraft, contentAsPublished, contentDescriptionMaxLength, contentHeadingMaxLength, getMaxLengthWithFieldErrorMessage, getRequiredErrorMessage } from "../Shared/Constants/AdminModuleConstants";
import ContentService from "../Shared/Services/ContentService";

export const ContentDetails = () => {
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const [id, setId] = useState();
    const [isPublished, setIsPublished] = useState(false);

    useEffect(() => {
        getContent();
    }, []);

    const getContent = () => {
        ContentService.getContent().then((response: any) => {
            setValue("description", response.data.description);
            setValue("heading", response.data.heading);
            setIsPublished(response.data.isPublished);
            setId(response.data.id);
        }).catch(() => {
            SweetAlertService.error("Error", `Something went wrong while getting content`);
        })
    }

    const onSubmitDraft = (data: any) => {
        data.isPublished = false;
        data.id = id;
        updateContent(data.id, data);
    };

    const onSubmitPublish = (data: any) => {
        data.isPublished = true;
        data.id = id;
        updateContent(data.id, data);
    };

    const onCancelClick = () => {
        getContent();
    };

    const updateContent = (id: number, data: any) => {
        data.heading = data.heading.trim();
        data.description = data.description.trim();
        ContentService.updateContent(id, data).then((response) => {
            if (response) {
                getContent();
                if (data.isPublished) {
                    SweetAlertService.success("Success", "Content has been successfully published");
                } else {
                    SweetAlertService.success("Success", "Content has been saved as a draft");
                }
            }
        }).catch(() => {
            SweetAlertService.error("Error", "Something went wrong while updating the content");
        })
    }

    return (
        <div className="container mt-2">
            <div className="hero-banner__image-container">
                <div className="card card-default">
                    <div className="card-body">
                        <form>
                            <div className="form-group">
                                <label className="col-sm control-label mb-1 ps-0">Heading</label>
                                <div className="col-sm-12 ps-0 pe-0">
                                    <input type="text" className="form-control"
                                        {...register("heading", {
                                            required: getRequiredErrorMessage("Heading"),
                                            maxLength: {
                                                value: contentHeadingMaxLength,
                                                message: getMaxLengthWithFieldErrorMessage("Heading", contentHeadingMaxLength)
                                            }
                                        })}
                                    />
                                    {errors.heading && (
                                        <span className="help-block m-b-none text-danger field-validation-valid">{errors.heading.message?.toString()}</span>
                                    )}
                                </div>
                            </div>
                            <br />
                            <div className="form-group">
                                <label className="col-sm control-label mb-1 ps-0">Main content</label>
                                <div className="col-sm-12 ps-0 pe-0">
                                    <textarea className="form-control" rows={3}
                                        {...register("description", {
                                            required: getRequiredErrorMessage("Description"),
                                            maxLength: {
                                                value: contentDescriptionMaxLength,
                                                message: getMaxLengthWithFieldErrorMessage("Description", contentDescriptionMaxLength)
                                            }
                                        })}>
                                    </textarea>
                                    {errors.description && (
                                        <span className="help-block m-b-none text-danger field-validation-valid">{errors.description.message?.toString()}</span>
                                    )}
                                </div>
                            </div>
                            <br />
                            <div className="form-group row">
                                <div className=" col-sm-offset">
                                    <button className="btn btn-primary" onClick={handleSubmit(onSubmitDraft)}>
                                        Save as draft
                                    </button>
                                    <button className="btn btn-primary ms-1" onClick={handleSubmit(onSubmitPublish)}>
                                        Publish
                                    </button>
                                    <button className="btn btn-secondary float-end" onClick={handleSubmit(onCancelClick)}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                            <br />
                            <div className=" col-sm-offset my-3 ">
                                <strong>Status:</strong> {isPublished ? contentAsPublished : contentAsDraft}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}